import React, {useEffect, useId, useState} from "react";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "../components/ui/Card";
import {Link, useParams} from "react-router-dom";
import DataTable from "../components/DataTable";
import {loggerColumns, piezometerColumns} from "../components/Columns";
import siteData from "../data/siteData.json"
import {ChevronRight, WifiHigh} from "lucide-react";
import {
    PiThermometerColdFill, PiThermometerFill,
    PiThermometerHotFill,
    PiThermometerSimpleFill,
    PiWifiHighFill,
    PiWifiLowFill,
    PiWifiMediumFill
} from "react-icons/pi";
import {TbCircleDotFilled} from "react-icons/tb";
import {BsThermometerSun} from "react-icons/bs";
import loggers from "../data/loggers.json"

function SiteDetailsPage() {
    const {siteId} = useParams();
    const {userId} = useParams();

    const [data, setData] = useState({});
    const [loggersData, setLoggersData] = useState([]);

    useEffect(() => {
        setData([])

        siteData.filter((search) => search.siteId === siteId).map((item) => {
           setData({ ...item})
       })
        loggers.map((item) => {
            setLoggersData((oldArray) => [...oldArray, item])
        })
        // piezometerData.slice(0,1120).map((item) => {
        //     setPzData((oldArray) => [...oldArray, {
        //         loggerId: item.Logger,
        //         dateTime: item.DateTime,
        //         ch1kPa: item.Ch1_kPa,
        //         ch2kPa: item.Ch2_kPa,
        //         ch3kPa: item.Ch3_kPa,
        //         ch4kPa: item.Ch4_kPa,
        //         ch5kPa: item.Ch5_kPa,
        //         ch1Temp: item.Ch1_Temp,
        //         ch2Temp: item.Ch2_Temp,
        //         ch3Temp: item.Ch3_Temp,
        //         ch4Temp: item.Ch4_Temp,
        //         ch5Temp: item.Ch5_Temp,
        //     }])
        // })
    }, [])

    return (
        <div className="w-11/12 mx-auto mt-4 space-y-8">
            <Card>
                <CardContent className="flex gap-x-0.5 items-center">
                    <CardHeader className="font-bold">All Sites</CardHeader>
                    <ChevronRight />
                    <CardHeader className="underline text-[#408EFAFF]">
                        <Link to={`/dashboard/${userId}/analysis`}>Site Detail</Link>
                    </CardHeader>
                </CardContent>
            </Card>
            <Card className="grid grid-cols-3 w-full">
                <div>
                    <CardHeader>
                        <CardTitle className="text-black border-dashed border-b pb-2 font-extralight">Site Details</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-2 gap-1">
                            <p className="font-bold">Site ID:</p>
                            <CardDescription>{siteId}</CardDescription>
                        </div>
                        <div className="grid grid-cols-2 gap-1">
                            <p className="font-bold">Site Name:</p>
                            <CardDescription>{data.siteName}</CardDescription>
                        </div>
                        <div className="grid grid-cols-2 gap-1">
                            <p className="font-bold">Status:</p>
                            <CardDescription>{data.status}</CardDescription>
                        </div>
                    </CardContent>
                </div>
                <div>
                    {/*if it is standpipe hide*/}
                    <CardHeader>
                        <CardTitle className="text-black border-dashed border-b pb-2 font-extralight">
                            Data Logger Legend
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="flex gap-x-2">
                            <div className="w-8 h-8 border-black">
                                <div className="from-green-700 via-green-400 bg-gradient-to-tr"></div>
                            </div>
                            <PiWifiHighFill className="mt-0.5" color="green" />
                            <CardDescription>Logger Healthy</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiWifiMediumFill className="mt-0.5" color="orange" />
                            <CardDescription>Logger Signal/Battery Low</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiWifiLowFill className="mt-0.5" color="red" />
                            <CardDescription>Logger Disconnected</CardDescription>
                        </div>
                    </CardContent>
                </div>
                <div>
                    <CardHeader>
                        <CardTitle className="text-black border-dashed border-b pb-2 font-extralight">Piezometer Legend</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="flex gap-x-2">
                            <PiThermometerFill color="green" className="mt-0.5" />
                            <CardDescription>Reading with normal range</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <BsThermometerSun color="orange" className="mt-0.5" />
                            <CardDescription>Engineering unit exceeding defined threshold</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiThermometerSimpleFill color="maroon" className="mt-0.5" />
                            <CardDescription>Temperature out of defined threshold</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiThermometerHotFill color="red" className="mt-0.5" />
                            <CardDescription>Engineering unit exceeding critical threshold</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiThermometerColdFill color="black" className="mt-0.5" />
                            <CardDescription>Faulty reading exceeding critical threshold</CardDescription>
                        </div>
                    </CardContent>
                </div>
            </Card>
            <Card>
                <CardHeader>
                    <DataTable columns={loggerColumns} data={loggersData} />
                </CardHeader>
            </Card>
        </div>
    )
}

export default SiteDetailsPage;